import { defineMessages } from 'react-intl';

export default defineMessages({
  login: {
    id: 'cboard.components.UserIcon.login',
    defaultMessage: 'Login or Sign up'
  }
});
